<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A4aY7h/tc-custom/9781607652557.jpg?1721442224618" alt="This image is the cover for the book Home Smoking and Curing of Meat, Fish and Game, Self-Sufficiency"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Home Smoking and Curing of Meat, Fish and Game, Self-Sufficiency
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Make the tastiest bacon, most delicious smoked fish, or perfectly cured salami without the need for high-tech equipment or expensive ingredients.</b></p><p>Smoking and curing originated as ways to preserve food before the advent of tin cans, freezers and vacuum packs. Nowadays, these ancient skills are enjoying a comeback as many of us look towards a more self-sufficient and rewarding way of preparing, storing and eating our food. In this book, author Joanna Farrow explains how with some basic ingredients and equipment, you can soon be salting, curing, air-drying, and smoking a whole range of seasonal and year-round produce. With clear instructions and advice to help you get started, plus twenty-five original recipes for meat, game, and shellfish, this book will give you the confidence and know-how to begin your own experiments. What could be more delicious than home-cured bacon, subtle smoked salmon, or air-dried ham? With guides to setting up your own smoker, preparing salt and brine cures, drying, and preserving, <i>Self-Sufficiency: Home Smoking and Curing</i> is the perfect introduction to making the most of meat, fish, game and poultry.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joanna Farrow
      </h2>
      
      <p class="authorDescription body article"><P>JOANNA FARROW is an experienced food writer and food stylist. She is the author of dozens of cookbooks on subjects ranging from fish and shellfish to children's cookery, cakes, and chocolate. Joanna worked as Deputy Cookery Editor for both BBC Vegetarian Good Food and Prima and is a regular contributor to many other magazines, including Woman &amp; Home, Best, House Beautiful, You, Men's Fitness, and Ready Steady Cook.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      IMM Lifestyle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b862c8d